export default "__VITE_ASSET__37165d0b__"